import { LanguageType } from "i18n";

const development = {
  keycloak: {
    url: "https://authentication-staging.api.adit.periplus.ch/auth",
    realm: "adit",
    clientId: "adit-spa",
    onLoad: "login-required",
    redirectUrl: "",
  },
  hasura: "http://localhost:1010/v1/graphql",
  blobStorage: {
    storageAccountName: "aditdocuments",
  },
  prefixMRSNumber: "MRT",
  maxFileSize: process.env.REACT_APP_MAX_FILE_SIZE || 100,
  wedclare: "http://staging.wedeclare.ch",
};

const test = {
  keycloak: {
    url: "https://authentication-staging.api.adit.periplus.ch/auth",
    realm: "adit",
    clientId: "adit-spa",
    onLoad: "login-required",
    redirectUrl: "",
  },
  hasura: "http://localhost:1010/v1/graphql",
  blobStorage: {
    storageAccountName: "aditdocuments",
  },
  prefixMRSNumber: "MRT",
  maxFileSize: process.env.REACT_APP_MAX_FILE_SIZE || 100,
  wedclare: "http://staging.wedeclare.ch",
};

const demo = {
  keycloak: {
    url: "https://authentication-demo.api.adit.periplus.ch/auth",
    realm: "adit",
    clientId: "adit-spa",
    onLoad: "login-required",
    redirectUrl: "",
  },
  hasura: "https://staging.api.adit.periplus.ch/v1/graphql",
  blobStorage: {
    storageAccountName: "aditdocuments",
  },
  prefixMRSNumber: "MRT",
  maxFileSize: process.env.REACT_APP_MAX_FILE_SIZE || 100,
  wedclare: "http://demo.periplus.ch",
};

const staging = {
  keycloak: {
    url: "https://authentication-staging.api.adit.periplus.ch/auth",
    realm: "adit",
    clientId: "adit-spa",
    onLoad: "login-required",
    redirectUrl: "",
  },
  hasura: "http://localhost:1010/v1/graphql",
  blobStorage: {
    storageAccountName: "aditdocuments",
  },
  prefixMRSNumber: "MRT",
  maxFileSize: process.env.REACT_APP_MAX_FILE_SIZE || 100,
  wedclare: "http://staging.wedeclare.ch",
};

const production = {
  keycloak: {
    url: "https://authentication.api.adit.periplus.ch/auth",
    realm: "adit",
    clientId: "adit-spa",
    onLoad: "login-required",
    redirectUrl: "https://adit.periplus.ch/login",
  },
  hasura: "https://production.api.adit.periplus.ch/v1/graphql",
  blobStorage: {
    storageAccountName: "aditdocumentsproduction",
  },
  prefixMRSNumber: "MRS",
  maxFileSize: process.env.REACT_APP_MAX_FILE_SIZE || 100,
  wedclare: "https://portal.wedeclare.ch",
};

// Default to development if not set
function getConfig() {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case "development":
      return development;
    case "test":
      return test;
    case "staging":
      return staging;
    case "production":
      return production;
    case "demo":
      return demo;
    default:
      return development;
  }
}

// Default to development if not set
const config = getConfig();

const configs = {
  // All "common", general config or initial values belong here...
  START_MESSAGE: "Hello World",
  graphQl: {
    url: config.hasura || "http://localhost:5000",
  },
  isProdMode: process.env.REACT_APP_ENVIRONMENT === "production",
  defaultLanguage: "en" as LanguageType,
  usedLanguages: ["en", "de"] as LanguageType[],
  dateFormat: "DD.MM.YYYY",
  ...config,
};

export default configs;
